'use client';

import Script from 'next/script';

import './UsableNet.scss';
import './UsableNet.experiment.scss';

const USABLE_NET_ICON_URL = 'https://a42cdn.usablenet.com/a42/petsmart/default/prod/cs-start';

const iconParams = new URLSearchParams({
    size: 'default',
    position: 'bottom-left',
    breakpoint: '600',
    'mobile-position': 'bottom-left',
});

export const UsableNetV2 = () => {
    const url = `${USABLE_NET_ICON_URL}?${iconParams.toString()}`;

    return (
        <Script
            defer
            src={url}
            data-ot-ignore // For OneTrust this accessibility script should be ignored, this is critical group - C0001
            data-rapid="true"
            id="usntA42start"
            strategy="afterInteractive"
            data-testid="velocity-usablenet-script"
        />
    );
};
